/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MarketplaceOrderBreakdownDTO interface.
 */
export function instanceOfMarketplaceOrderBreakdownDTO(value) {
    return true;
}
export function MarketplaceOrderBreakdownDTOFromJSON(json) {
    return MarketplaceOrderBreakdownDTOFromJSONTyped(json, false);
}
export function MarketplaceOrderBreakdownDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'flag': json['flag'] == null ? undefined : json['flag'],
        'ordersCount': json['ordersCount'] == null ? undefined : json['ordersCount'],
        'unitsCount': json['unitsCount'] == null ? undefined : json['unitsCount'],
        'revenueUsd': json['revenueUsd'] == null ? undefined : json['revenueUsd'],
        'netProfitUsd': json['netProfitUsd'] == null ? undefined : json['netProfitUsd'],
        'profitPercent': json['profitPercent'] == null ? undefined : json['profitPercent'],
        'cancelledCount': json['cancelledCount'] == null ? undefined : json['cancelledCount'],
        'returnedCount': json['returnedCount'] == null ? undefined : json['returnedCount'],
        'refundLossUsd': json['refundLossUsd'] == null ? undefined : json['refundLossUsd'],
    };
}
export function MarketplaceOrderBreakdownDTOToJSON(json) {
    return MarketplaceOrderBreakdownDTOToJSONTyped(json, false);
}
export function MarketplaceOrderBreakdownDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'countryCode': value['countryCode'],
        'flag': value['flag'],
        'ordersCount': value['ordersCount'],
        'unitsCount': value['unitsCount'],
        'revenueUsd': value['revenueUsd'],
        'netProfitUsd': value['netProfitUsd'],
        'profitPercent': value['profitPercent'],
        'cancelledCount': value['cancelledCount'],
        'returnedCount': value['returnedCount'],
        'refundLossUsd': value['refundLossUsd'],
    };
}
